import { PaymentContractInformations } from "../../../common/types";
import { ContractTypes } from "../../../common/types/FirmContractTypes";


type Props = {
    contractList: Array<PaymentContractInformations>
}
const FirmContractList = (props: Props) => {



    const getContractByType = (item: PaymentContractInformations) => {

        switch (item.contracttype) {
            case ContractTypes.contactForm:
                return {
                    label: "İletişim Bilgileri"
                }
            case ContractTypes.distanceSale:
                return {
                    label: "Mesafeli Satış Sözleşmesi"
                }
            case ContractTypes.kvkkContracts:
                return {
                    label: "KVKK Aydınlatma Metni"
                }
            case ContractTypes.refundTerms:
                return {
                    label: "İade Bilgileri"
                }
            case ContractTypes.securityInfo:
                return {
                    label: "Güvenlik Bilgileri"
                }
            case ContractTypes.serviceContracts:
                return {
                    label: "Hizmet Sözleşmesi"
                }
            default:
                break;
        }
    }


   

    return (
        <div>
            {props.contractList?.map((item, index) => item.contract && item.contract != "<p>&nbsp;</p>" ? (
                <div key={"contract" + index}  >
                    <a >
                        {getContractByType(item)?.label}
                    </a>
                </div>
            ) : null)} 
        </div>
    );
}
export default FirmContractList;